import { Link } from "react-router-dom";
import { CloudLightning, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Homepage callout for Storm Response (closed pilot). Keep claims to what the
 * product does; no statistics or speed promises.
 */
const StormResponseCallout = () => {
  return (
    <section className="py-12 px-4 bg-muted/40 border-y">
      <div className="container mx-auto max-w-4xl flex flex-col md:flex-row items-center gap-6">
        <div className="shrink-0 w-14 h-14 rounded-lg bg-primary text-primary-foreground flex items-center justify-center">
          <CloudLightning className="h-7 w-7" />
        </div>
        <div className="flex-1 text-center md:text-left space-y-1">
          <h2 className="text-xl md:text-2xl font-bold text-foreground">
            New: Storm Response for roofers
          </h2>
          <p className="text-muted-foreground">
            When a storm hits your service area, Storm Response prepares Google and Microsoft
            search ads for the ZIP codes it hit. You set the budget and approve each campaign.
            Included in your 7-day free trial.
          </p>
        </div>
        <Button size="lg" asChild className="shrink-0">
          <Link to="/storm-response">
            See how it works <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default StormResponseCallout;
